/**
 * Lightbox fuer die Bildergalerie der Standort-Detailseite (siehe Show.html,
 * .cc-chipmap-detail__image-trigger / #chipmap-lightbox). Bewusst ohne externe Bibliothek,
 * analog zum restlichen Vanilla-JS-Stil des Projekts (siehe chip_connect_bw_site/Main.js).
 */
document.addEventListener('DOMContentLoaded', () => {
    const lightbox = document.getElementById('chipmap-lightbox');
    const triggers = Array.from(document.querySelectorAll('.cc-chipmap-detail__image-trigger'));
    if (!lightbox || triggers.length === 0) {
        return;
    }

    const imageEl = lightbox.querySelector('.cc-lightbox__image');
    const prevButton = lightbox.querySelector('[data-lightbox-prev]');
    const nextButton = lightbox.querySelector('[data-lightbox-next]');
    const closeButton = lightbox.querySelector('.cc-lightbox__close');
    let currentIndex = 0;
    let lastFocusedElement = null;

    function show(index) {
        currentIndex = (index + triggers.length) % triggers.length;
        const trigger = triggers[currentIndex];
        imageEl.src = trigger.dataset.lightboxSrc;
        imageEl.alt = trigger.dataset.lightboxAlt || '';
    }

    function open(index) {
        lastFocusedElement = document.activeElement;
        show(index);
        lightbox.hidden = false;
        document.body.classList.add('cc-lightbox-open');
        closeButton.focus();
        document.addEventListener('keydown', onKeydown);
    }

    function close() {
        lightbox.hidden = true;
        document.body.classList.remove('cc-lightbox-open');
        document.removeEventListener('keydown', onKeydown);
        if (lastFocusedElement instanceof HTMLElement) {
            lastFocusedElement.focus();
        }
    }

    function getFocusable() {
        return Array.from(
            lightbox.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])')
        ).filter((el) => !el.hidden);
    }

    function onKeydown(event) {
        if (event.key === 'Escape') {
            close();
        } else if (event.key === 'Tab') {
            const focusable = getFocusable();
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        } else if (event.key === 'ArrowLeft') {
            show(currentIndex - 1);
        } else if (event.key === 'ArrowRight') {
            show(currentIndex + 1);
        }
    }

    triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => open(index));
    });

    lightbox.querySelectorAll('[data-lightbox-close]').forEach((element) => {
        element.addEventListener('click', close);
    });

    prevButton?.addEventListener('click', () => show(currentIndex - 1));
    nextButton?.addEventListener('click', () => show(currentIndex + 1));
});
